import apiClient from '../helpers/apiClient'

// E1 (Suggest-to-Nobilis) service. BLOCKED: the endpoints below ship in the E1-backend (Suggestion
// model + admin queue), NOT yet deployed. Built against the expected contract; callers degrade
// gracefully (return null / empty) so the UI renders and only fails the actual network action.
//
// Expected contract (camelCased by djangorestframework_camel_case):
//   Member submit:   POST /experiences/suggestions/
//     body: { title, description, category?, location?, why?, wantsToLead? }
//   Staff list:      GET  /experiences/suggestions/admin/?status=&search=&limit=&offset=
//     -> { count, results: [ Suggestion ] }
//   Staff detail:    GET  /experiences/suggestions/admin/<id>/
//   Status change:   PATCH /experiences/suggestions/admin/<id>/  { status }
//   Convert:         POST /experiences/suggestions/admin/<id>/convert/   (creates an Experience,
//                    sets status=converted; returns the created experience id)
//
//   Suggestion = { id, title, description, category, location, why, wantsToLead,
//                  status, statusDisplay, submittedBy: {id, name, email}, createdAt }

export interface SuggestionPayload {
  title: string
  description: string
  category?: string
  location?: string
  why?: string
  wantsToLead?: boolean
  submitted_by_id?: number
}

export interface SuggestionListParams {
  status?: string
  search?: string
  limit?: number
  offset?: number
}

const MEMBER_URL = '/suggestions/'
const ADMIN_URL = '/suggestions/admin/'

export const createSuggestion = async (payload: SuggestionPayload) => {
  const response = await apiClient.post(MEMBER_URL, payload)
  return response.data
}

export const getSuggestions = async (params: SuggestionListParams = {}) => {
  const response = await apiClient.get(ADMIN_URL, {params})
  return response.data
}

export const getSuggestion = async (id: number) => {
  const response = await apiClient.get(`${ADMIN_URL}${id}/`)
  return response.data
}

export const updateSuggestionStatus = async (id: number, status: string) => {
  const response = await apiClient.patch(`${ADMIN_URL}${id}/`, {status})
  return response.data
}

export const convertSuggestion = async (id: number) => {
  const response = await apiClient.post(`${ADMIN_URL}${id}/convert/`)
  return response.data
}
